<template>
  <div>
    <div class="app-main-layout">
      <Navbar @clickSideBarMenu="isOpen = !isOpen" v-model="isOpen"/>

      <Sidebar @clickSideBarMenu1="isOpen = !isOpen" v-model="isOpen" />
      
      <!-- <main class="app-content" :class="{full: !isOpen}">         -->    
      <main class="app-content full">       
        
        <div class="app-page">
          <router-view />
        </div>
      </main>
    </div>
  </div>
</template>

<script>
import Navbar from "@/components/Navbar";
import Sidebar from "@/components/Sidebar";

export default {
  name: "main-layout",
  data: () => ({
    isOpen: false,
    loading: true,
    sidenav1: null
  }),
  computed: {
    serverMsg() {
      return this.$store.getters.serverMsg;
    },
    errorMain() {
      return this.$store.getters.errorMain;
    }   
  },
  watch: {
    errorMain(text) {
      if (text) {
        this.$message(this.$transmsg(text));
        this.$store.commit("clearErrorMain");
      }
    }
  },
  components: {
    Navbar,
    Sidebar
  }
};
</script>
